import { constants } from "node:fs";
import { open, rename, rm } from "node:fs/promises";
import { randomUUID } from "node:crypto";
import { join } from "node:path";

const FILE_MODE = 0o600;

async function syncContainingDirectory(directory) {
  let handle;
  try {
    handle = await open(directory, constants.O_RDONLY | (constants.O_DIRECTORY ?? 0));
    await handle.sync();
  } catch (error) {
    const code = error?.code;
    // Directory fsync is unavailable on Windows and a few filesystems. The
    // atomic rename is still safe there; never leak descriptors on this path.
    if (!["EINVAL", "ENOTSUP", "ENOSYS", "EBADF", "EISDIR", "EPERM"].includes(code ?? "")) {
      throw error;
    }
  } finally {
    await handle?.close().catch(() => undefined);
  }
}

/** Atomically persist the shared recovery-code file with owner-only permissions. */
export async function writeHistoryRecoveryCodeFile({ directory, tenantId, code }) {
  const filePath = join(directory, `${tenantId}.json`);
  const tempPath = join(directory, `.${tenantId}.${randomUUID()}.tmp`);
  const stored = { version: 1, tenantId, code };
  let handle;
  try {
    handle = await open(
      tempPath,
      constants.O_WRONLY | constants.O_CREAT | constants.O_EXCL,
      FILE_MODE,
    );
    await handle.writeFile(JSON.stringify(stored), { encoding: "utf8" });
    await handle.chmod(FILE_MODE);
    await handle.sync();
    await handle.close();
    handle = undefined;
    await rename(tempPath, filePath);
    await syncContainingDirectory(directory);
  } finally {
    await handle?.close().catch(() => undefined);
    await rm(tempPath, { force: true }).catch(() => undefined);
  }
}
